import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const faqKeys = [
  { q: 'faq_1_q', a: 'faq_1_a' },
  { q: 'faq_2_q', a: 'faq_2_a' },
  { q: 'faq_3_q', a: 'faq_3_a' },
];

export default function FaqSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="mx-auto w-full max-w-4xl px-4 py-16 md:px-6 md:py-24">
      <div className="text-center">
        <h2 className="font-heading text-2xl font-semibold text-foreground-950 md:text-4xl">{t('faq_title')}</h2>
        <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{t('faq_subtitle')}</p>
      </div>

      <div className="mt-10 space-y-3">
        {faqKeys.map((item, idx) => {
          const isOpen = openIndex === idx;
          return (
            <div
              key={item.q}
              className="overflow-hidden rounded-lg border border-background-200/70 bg-white"
            >
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? null : idx)}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm font-semibold text-foreground-900 md:text-base">{t(item.q)}</span>
                <span
                  className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-foreground-500 transition-colors ${
                    isOpen ? 'bg-primary-100 text-primary-600' : 'bg-background-100'
                  }`}
                >
                  <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'} />
                </span>
              </button>
              {isOpen && (
                <div className="px-5 pb-5">
                  <p className="text-sm leading-relaxed text-foreground-600">{t(item.a)}</p>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}